import _ from 'lodash';

// cache模块状态
const state = {
    // 缓存状态
    caches: {}
};

// cache模块mutations
const mutations = {
    /**
     * 设置缓存
     * @param state
     * @param value
     */
    setCache(state, { key, options }) {
        const res = state.caches[key];
        if (res) {
            state.caches[key] = _.merge(res, options);
        } else {
            state.caches[key] = options;
        }
    },
    /**
     * 删除缓存
     * @param state
     * @param key
     */
    delCache(state, key) {
        delete state.caches[key];
    }
};

// cache模块actions
const actions = {
    /**
     * 设置缓存
     * @param context
     * @param value
     */
    setCache({ commit, rootState }, { key, options }) {
        const walletPubId = rootState.user.walletPubId;
        commit('setCache', {
            key: `${walletPubId}-${key}`,
            options
        });
    }
};

// cache模块getters
const getters = {
    /**
     * 设置缓存
     * @param state
     * @param getter
     * @param rootState,
     * @param rootGetter
     */
    getCache(state, getter, rootState, rootGetter) {
        const walletPubId = rootState.user.walletPubId;
        return key => {
            return state.caches[`${walletPubId}-${key}`];
        };
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
